import { Action, Dispatch } from 'redux';

import { displayTransition } from 'FRONTEND/reducers/consultationViewSlice';

/**
 * setup the form specific listeners for pjax, based on id.
 *
 * Currently concerned:
 *  - #consultations-dispatch
 */
export const setupPjaxFormSpecificListeners = (dispatch: Dispatch<Action>) => {
  // clear up the displayedTransition state after dispatching a consultation, which makes the button usable again immediatly
  // instead of waiting for a refresh
  $(document).on('submit', '#consultations-dispatch', function handleSubmitDispatch() {
    dispatch(displayTransition({ transition: '' }));
  });
};
